import { ACCOUNTS_TABLE_BODY_CELL_CLASSNAME } from 'src/components/PortfolioPage/PortfolioAccountsSubPage/AccountsTable/consts';
import { UseAccountsTable } from 'src/components/PortfolioPage/PortfolioAccountsSubPage/AccountsTable/hooks/useAccountsTable';
import { TableCell } from 'src/components/primitives/Table/Table';
import NumberDisplay from 'src/components/NumberDisplay/NumberDisplay';
import { TEN_THOUSAND_BIGNUM } from 'src/constants/math';
import { cj } from 'src/utils/classNames';

interface Props extends Pick<
	UseAccountsTable,
	'sumDeposits' | 'sumBorrows' | 'sumNetUsdValue' | 'numAccountsAtRisk'
> {
	numColumns: number;
}

export default function AccountsTableFooter({
	sumDeposits,
	sumBorrows,
	sumNetUsdValue,
	numAccountsAtRisk,
	numColumns,
}: Props) {
	return (
		<>
			<TableCell className={ACCOUNTS_TABLE_BODY_CELL_CLASSNAME}>
				Summary
			</TableCell>
			<TableCell className={ACCOUNTS_TABLE_BODY_CELL_CLASSNAME}>
				<NumberDisplay
					value={sumDeposits}
					type="currency"
					millify={sumDeposits.abs().gte(TEN_THOUSAND_BIGNUM)}
					isAccountValueToHide
				/>
			</TableCell>
			<TableCell className={ACCOUNTS_TABLE_BODY_CELL_CLASSNAME}>
				<NumberDisplay
					value={sumBorrows}
					type="currency"
					millify={sumBorrows.abs().gte(TEN_THOUSAND_BIGNUM)}
					isAccountValueToHide
				/>
			</TableCell>

			<TableCell className={ACCOUNTS_TABLE_BODY_CELL_CLASSNAME}>
				<NumberDisplay
					value={sumNetUsdValue}
					type="currency"
					millify={sumNetUsdValue.abs().gte(TEN_THOUSAND_BIGNUM)}
					isAccountValueToHide
				/>
			</TableCell>
			<TableCell
				className={cj(
					'w-full whitespace-nowrap',
					numAccountsAtRisk === 0
						? 'text-text-positive-green-button'
						: 'text-text-negative-red-button',
					ACCOUNTS_TABLE_BODY_CELL_CLASSNAME
				)}
				// Span the rest of the table.
				colSpan={numColumns - 4}
			>
				{`${numAccountsAtRisk} account${
					numAccountsAtRisk != 1 ? 's' : ''
				} at risk`}
			</TableCell>
		</>
	);
}
